import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FooterNavigation, Header, PaginationHelper, TitleBar } from "webapp/components";
import CRRMemberInformationForm from "webapp/components/Partner/CRR/CRRMemberInformationForm/CRRMemberInformationForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

function CRRMemberInformation(props) {
  const { t } = useTranslation();
  const [showFooter, setShowFooter] = useState(true);
  const [memberInfo, setMemberInfo] = useState(null);
  const [selectedMember, setSelectedMember] = useState(null);

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("APIA.PolicyInformation.TitleBar1")}</strong>
          <br />
        </p>
      </>
    ),
  };

  const onUserSelectMember = (contractData, member) => {
    devLog("onUserSelectMember", contractData, member);
    setMemberInfo(contractData);
    setSelectedMember(member);
  };

  const onUserNext = () => {
    onUserSelectMember(memberInfo, selectedMember);
    if (memberInfo && selectedMember) {
      devLog("onMemberNext", memberInfo?.name);
      props.context.setState(
        {
          accountRef: memberInfo.accountRef,
          memberRef: selectedMember.memberRef,
          contactRef: selectedMember.memberRef,
          Year: memberInfo.year,
          Make: memberInfo.make,
          Model: memberInfo.model,
          Color: memberInfo.color,
          Weight: memberInfo.weight,
          allowVehicleInfoEdits: false,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {
          props.context.saveWebAppState(props.context);
        },
      );
    } else {
      /**
       * Notify the user that an unknown error has occurred and to try again
       * set the webAppState to the search page
       */
      props.context.setState(
        {
          MemberNumber: null,
          webAppState: AppState.ConfirmVehicle,
        },
        () => {},
      );
    }
    devLog("onUserNext");
    if (typeof props.onUserNext === "function") {
      props.onUserNext();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };
  const onContractLookupComplete = (success) => {
    setShowFooter(!!success);
  };

  return (
    <>
      <div className="CustCollectPage">
        <Header
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          information={t("APIA.PolicyInformation.PolicyInformationHeader1")}
        />
        <TitleBar data={LocateUserObj} />
        <PaginationHelper context={props.context} />
        <CRRMemberInformationForm
          context={props.context}
          currState={props.currState}
          onUserBack={props.backButtonFunc}
          onUserCancel={onUserCancel}
          onLoad={onContractLookupComplete}
          onSelect={onUserSelectMember}
        />
      </div>

      {showFooter ? <FooterNavigation onCancelClick={onUserCancel} onNextClick={onUserNext} /> : <></>}
    </>
  );
}

export default CRRMemberInformation;
